<template>
  <div>
    <div class="news">
      <h2>
        <!-- <i class="el-icon-map-location" /> -->
        {{ info.positionName }}
      </h2>
      <!-- <h2>{{ $t("join.jobDetail") }}</h2> -->
      <h4 style="margin: 20px 0;">{{ info.positionName }} <span class="divider">|</span> {{ info.payment }} <span class="divider">|</span> <i class="el-icon-map-location" /> {{ info.city }}</h4>
      <hr style="background:#ddd">
      <!-- <h2>招聘城市</h2>
      <h4>{{ info.city }}</h4> -->
      <div class="join-title">{{ $t("join.jobDuties") }}</div>
      <h4 v-html="info.jobDuties"></h4>
      <div class="join-title">{{ $t("join.jobRequirements") }}</div>
      <h4 v-html="info.jobRequirements"></h4>
      <div class="join-title">{{ $t("join.welfare") }}</div>
      <h4 v-html="welfare"></h4>
      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" size="mini" @click="applyJob">{{
          $t("join.application")
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPositionsInfo, GetWelfareInfo } from "../../api/web";

export default {
  name: "detail",
  data() {
    return {
      info: {},
      welfare: "",
    };
  },
  methods: {
    getDetails() {
      const comDic = {
        1: this.$t('join.clinical'),
        2: this.$t('join.meta'),
        3: this.$t('join.cric'),
      };
      GetPositionsInfo(this.positionId).then((res) => {
        if (res.status) {
          res.data.companyName = comDic[res.data.companyId];
          this.info = res.data;
        } else {
          this.$router.push({ name: "JOINUS" });
        }
      });
      GetWelfareInfo().then((res) => {
        if (res.status) {
          this.welfare = res.data;
        }
      });
    },
    applyJob(info) {
      const { companyId, positionId } = this;
      this.$router.push({
        name: "APPLICATION",
        query: { positionId, companyId },
      });
    },
  },
  mounted() {
    this.getDetails();
  },
  computed: {
    positionId() {
      return this.$route.query.positionId |sessionStorage.getItem('positionId');
    },
    companyId() {
      return this.$route.query.companyId | sessionStorage.getItem('companyId');
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/constant.less";

.news {
  // width: @page-width;
  width: 792px;
  margin: 0 auto;
  padding: 30px 10px;
  .join-title {
    font-size: 18px;
    font-weight: bolder;
    padding: 25px 0 20px;
  }
  .divider {
    color: #ddd;
  }

  .carousel-img {
    width: 50%;
    margin: 0 auto;
  }

  .cover-img {
    height: 100%;
    max-width: 90%;
  }

  .news-cover {
    max-height: 300px;
    max-width: 80%;
  }
}

.news-title {
  background-color: #f6f6f6;
  padding: 15px 15px 15px 0;
  // padding-left: calc(~"(100% - 1200px) / 2");
  font-size: 26px;
  .p1 {
    width: 792px;
    margin: 0 auto;
  }
  .date {
    margin-top: 10px;
    color: @active-color;
    font-size: 14px;
  }
}

.content {
  margin-top: 15px;

  img {
    max-width: 300px;
  }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .news {
    width: 95%;

    .carousel-img {
      width: 90%;
    }
  }

  .news-title {
    padding: 15px;
    font-size: 21px;
    .p1 {
      width: 100%;
    }
  }
}
</style>